import * as fflip from 'fflip';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from './user.service';
import { criteria } from './feature-flags/criteria';
import { features } from './feature-flags/features';
import { WindowService } from './window.service';
import { OrganizationType, Plan } from 'services/authenticatedUser';
import { Observable, of } from 'rxjs';

/**
 * Legacy fflip-based feature evaluation using in-repo `criteria` and `features` definitions.
 *
 * @deprecated Use `DynamicFeatureFlagService` from `shared/services` instead. New work must use
 * OpenFeature / Flagsmith via `DynamicFeatureFlagService.isFeatureEnabled$()` (and related APIs),
 * not this client-only fflip stack.
 */
@Injectable()
export class FeatureService {
    /** @deprecated Use `DynamicFeatureFlagService` instead. */
    constructor(
        private userService: UserService,
        private windowService: WindowService,
        private router: Router
    ) {
        fflip.config({ criteria, features });
    }

    /** @deprecated Use `DynamicFeatureFlagService.isFeatureEnabled$()` instead. */
    public async isFeatureEnabled(featureName: string, extraParams?: any): Promise<boolean> {
        return fflip.isFeatureEnabledForUser(featureName, this.getContext(extraParams));
    }

    /** @deprecated Use `DynamicFeatureFlagService.isFeatureEnabled$()` instead. */
    public isFeatureEnabledObservable(featureName: string, extraParams?: any): Observable<boolean> {
        return of(fflip.isFeatureEnabledForUser(featureName, this.getContext(extraParams)));
    }

    /** @deprecated Legacy helper only; prefer `DynamicFeatureFlagService` for new code. */
    private getUser(): CriteriaUser {
        return {
            email: this.userService.getEmail(),
            organization: {
                _id: this.userService.getOrganizationId(),
                type: this.userService.getOrganization()?.type,
                plan: this.userService.getPlan()
            }
        };
    }

    /** @deprecated Legacy helper only; prefer `DynamicFeatureFlagService` for new code. */
    private getContext(extraParams: any): CriteriaContext {
        return {
            user: this.getUser(),
            location: {
                path: this.router.url,
                host: this.windowService.location.host
            },
            extraParams
        };
    }
}

export interface CriteriaContext {
    user: CriteriaUser;
    location: { path: string; host: string };
    extraParams: any;
}

interface CriteriaUser {
    email: string;
    organization: {
        _id: string;
        type: OrganizationType;
        plan: Plan;
    };
}
